import Vue from "vue";
import App from "./App.vue";
import "ag-grid-enterprise";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import AuthLayout from "@/layouts/AuthLayout";
import MobileLayout from "@/layouts/MobileLayout";
import ProjectListLayout from "@/layouts/ProjectListLayout";
import DashboardLayout from "@/layouts/DashboardLayout";
import DefaultLayout from "@/layouts/DefaultLayout";
import DetailsLayout from "@/layouts/DetailsLayout";

import LoadingIndicator from "@/components/common/Loading";
// import "./assets/scss/app.scss";
import "./assets/scss/theme.scss";
// import { BootstrapVue,VBModal,IconsPlugin ,BootstrapVueIcons  } from 'bootstrap-vue';
// import { BModal } from 'bootstrap-vue'
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css';
import "animate.css/animate.min.css";
import { LicenseManager } from "@ag-grid-enterprise/core";
import "ag-grid-enterprise";
// window.$ = window.jQuery = require('jquery');
// PLUGINS
import i18n from "./plugins/vue-i18n";
import "./plugins/vue-google-maps";
import "./plugins/vue-shortkey";
import "./plugins/vue-head";
import "./plugins/vue-gtag";
import "./plugins/apexcharts";
import "./plugins/echarts";
import "./plugins/animate";
import "./plugins/clipboard";
import "./plugins/moment";

// FILTERS
import "./filters/capitalize";
import "./filters/lowercase";
import "./filters/uppercase";
import "./filters/formatCurrency";
import "./filters/formatDate";

Vue.use(Toast, { position: "top-center", delay: 1500 });
LicenseManager.setLicenseKey(
  "For_Trialing_ag-Grid_Only-Not_For_Real_Development_Or_Production_Projects-Valid_Until-18_December_2021_[v2]_MTYzOTc4NTYwMDAwMA==6e38e7593a6595db67c06381988ed88e"
);
Vue.use(Loading, {
  loader: "bars"
});

Vue.component("auth-layout", AuthLayout);
Vue.component("mobile-layout", MobileLayout);
Vue.component("dashboard-layout", DashboardLayout);
Vue.component("default-layout", DefaultLayout);
Vue.component("project-layout", ProjectListLayout);
Vue.component("details-layout", DetailsLayout);
Vue.component("loading", LoadingIndicator);

import globalMixin from "../src/mixins/global";
Vue.mixin(globalMixin);

import setupInterceptors from "../src/repository/Interceptor";
setupInterceptors(store);

// Vue.component('b-modal', BModal);
// Vue.directive('b-modal', VBModal)
Vue.config.productionTip = false;
// Vue.use(BootstrapVue);
// Vue.use(IconsPlugin),
// Vue.use(BootstrapVueIcons),
new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
